var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.socials),function(icon,index){return _c('v-btn',{key:index,staticClass:"socials ma-0 pa-0",attrs:{"plain":"","href":icon.path,"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"mr-4",attrs:{"icon":icon.icon,"color":_vm.color}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }